import { RESOURCE_NAME } from '@esentai/core/features/parkingTowerStopList/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadParkingStopList = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateParkingStopList = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateParkingStopList = authorizeIf(canUpdate(RESOURCE_NAME));
